import "core-js/modules/es.object.assign.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Link } from 'react-router-dom';
import { FileText } from '@finect/tabular-icons/fileText';
import { Video } from '@finect/tabular-icons/video';
import { ExternalLink } from '@finect/tabular-icons/externalLink';
import { getArticlePath, getArticleRel } from '../../../../../Articles';
import { IconText } from '../../../../../Grid';
import { StyledTextContainer, StyledLink } from '../partials';
var TYPES = {
  article: function article(_article) {
    return {
      icon: React.createElement(FileText, null),
      link: {
        as: Link,
        to: getArticlePath(_article),
        rel: getArticleRel(_article)
      }
    };
  },
  video: function video(article) {
    return {
      icon: React.createElement(Video, null),
      link: {
        href: article.body.url,
        rel: 'nofollow noopener noreferrer'
      }
    };
  },
  'external-link': function externalLink(article) {
    return {
      icon: React.createElement(ExternalLink, null),
      link: {
        href: article.body.url,
        rel: 'nofollow noopener noreferrer'
      }
    };
  }
};
export var ManagerContent = function ManagerContent(_ref) {
  var content = _ref.content,
    _ref$withIcon = _ref.withIcon,
    withIcon = _ref$withIcon === void 0 ? true : _ref$withIcon;
  var fn = TYPES[content.type] || TYPES.article;
  var data = fn(content);
  if (data) {
    return withIcon ? React.createElement(IconText, {
      icon: data.icon
    }, React.createElement(AppLink, _extends({}, data.link, {
      "data-fi-event": "manufacturerArticle"
    }), content.title)) : React.createElement(StyledTextContainer, null, React.createElement(StyledLink, _extends({}, data.link, {
      "data-fi-event": "manufacturerArticle"
    }), content.title));
  }
  return null;
};